import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
    {
        path: "/",
        redirect: {
            name: "index"
        }
    },{
        path: "/index",
        name: "index",
        component: () => import("./views/index/index.vue")
    },{
        path: "/trading",
        name: "trading",
        component: () => import("./views/trading/index.vue")
    },{
        path: "/tradinghis",
        name: "tradinghis",
        component: () => import("./views/trading/allhis.vue")
    },{
        path: "/item",
        name: "item",
        component: () => import("./views/item/index.vue")
    },{
        path: "/item/:code",
        name: "itemDetail",
        component: () => import("./views/item/detail.vue")
    },{
        path: "/doinvest/:code",
        name: "doinvest",
        component: () => import("./views/item/buy.vue")
    },{
        path: "/activity",
        name: "activity",
        component: () => import("./views/activity/index.vue")
    },{
        path: "/activity/:code",
        name: "activityDetail",
        component: () => import("./views/activity/detail.vue")
    },{
        path: "/user",
        name: "user",
        component: () => import("./views/user/index.vue")
    },{
        path: "/pay",
        name: "pay",
        component: () => import("./views/user/pay.vue")
    },{
        path: "/account",
        name: "account",
        component: () => import("./views/user/account.vue")
    },{
        path: "/addcount",
        name: "addcount",
        component: () => import("./views/user/addcount.vue")
    },{
        path: "/addcountUsdt",
        name: "addcountUsdt",
        component: () => import("./views/user/addcountUsdt.vue")
    },{
        path: "/transfer",
        name: "transfer",
        component: () => import("./views/user/transfer.vue")
    },{
        path: "/moneybag",
        name: "moneybag",
        component: () => import("./views/user/moneybag.vue")
    },{
        path: "/moneyhis",
        name: "moneyhis",
        component: () => import("./views/user/moneyhis.vue")
    },{
        path: "/jifenhis",
        name: "jifenhis",
        component: () => import("./views/user/jifenhis.vue")
    },{
        path: "/jifentask",
        name: "jifentask",
        component: () => import("./views/user/jifentask.vue")
    },{
        path: "/teamreglistx/:code",
        name: "teamreglistx",
        component: () => import("./views/user/teamreglistx.vue")
    },{
        path: "/teamreglist/:code",
        name: "teamreglist",
        component: () => import("./views/user/teamreglist.vue")
    },
    {
        path: "/rechargeRecord",
        name: "rechargeRecord",
        component: () => import("./views/user/rechargeRecord.vue")
    },{
        path: "/withdrawRecord",
        name: "withdrawRecord",
        component: () => import("./views/user/withdrawRecord.vue")
    },{
        path: "/jrank",
        name: "jrank",
        component: () => import("./views/user/jrank.vue")
    },{
        path: "/mrank",
        name: "mrank",
        component: () => import("./views/user/mrank.vue")
    },{
        path: "/cashlist",
        name: "cashlist",
        component: () => import("./views/user/cashlist.vue")
    },{
        path: "/teamreward",
        name: "teamreward",
        component: () => import("./views/user/teamreward.vue")
    },{
        path: "/login",
        name: "login",
        component: () => import("./views/user/login.vue")
    },{
        path: "/addr",
        name: "addr",
        component: () => import("./views/user/addr.vue")
    },{
        path: "/register",
        name: "register",
        component: () => import("./views/user/register.vue")
    },{
        path: "/forgetpwd",
        name: "forgetpwd",
        component: () => import("./views/user/forgetpwd.vue")
    },{
        path: "/invest2",
        name: "invest2",
        component: () => import("./views/user/invest2.vue")
    },{
        path: "/invest",
        name: "invest",
        component: () => import("./views/user/invest.vue")
    },{
        path: "/invest/trx/:code",
        name: "investtrx",
        component: () => import("./views/user/invest.vue")
    },{
        path: "/invest/wx",
        name: "wx",
        component: () => import("./views/user/invest_qrcode.vue")
    },{
        path: "/invest/usdt",
        name: "usdt",
        component: () => import("./views/user/invest_qrcode.vue")
    },{
        path: "/invest/bank",
        name: "bankpay",
        component: () => import("./views/user/invest_bank.vue")
    },{
        path: "/cash",
        name: "cash",
        component: () => import("./views/user/cash.vue")
    },{
        path: "/teamIncome",
        name: "teamIncome",
        component: () => import("./views/user/teamIncome.vue")
    },{
        path: "/miningProfits",
        name: "miningProfits",
        component: () => import("./views/user/miningProfits.vue")
    },{
        path: "/activityIncome",
        name: "activityIncome",
        component: () => import("./views/user/activityIncome.vue")
    },{
        path: "/tasklist",
        name: "tasklist",
        component: () => import("./views/user/tasklist.vue")
    },{
        path: "/googlecode",
        name: "googlecode",
        component: () => import("./views/user/googlecode.vue")
    },{
        path: "/infoset",
        name: "infoset",
        component: () => import("./views/user/infoset.vue")
    },{
        path: "/vip",
        name: "vip",
        component: () => import("./views/user/vip.vue")
    },{
        path: "/viptask",
        name: "viptask",
        component: () => import("./views/user/viptask.vue")
    },{
        path: "/viptaskhigh",
        name: "viptaskhigh",
        component: () => import("./views/user/viptaskhigh.vue")
    },{
        path: "/viptaskfree",
        name: "viptaskfree",
        component: () => import("./views/user/viptaskfree.vue")
    },{
        path: "/jifen",
        name: "jifen",
        component: () => import("./views/user/jifen.vue")
    },{
        path: "/jifenshop",
        name: "jifenshop",
        component: () => import("./views/user/jifenshop.vue")
    },{
        path: "/meng",
        name: "meng",
        component: () => import("./views/user/meng.vue")
    },{
        path: "/jifenlog",
        name: "jifenlog",
        component: () => import("./views/user/jifenlog.vue")
    },{
        path: "/joinperson",
        name: "joinperson",
        component: () => import("./views/user/joinperson.vue")
    },{
        path: "/jointeam",
        name: "jointeam",
        component: () => import("./views/user/jointeam.vue")
    },{
        path: "/joincom",
        name: "joincom",
        component: () => import("./views/user/joincom.vue")
    },{
        path: "/viptasklist",
        name: "viptasklist",
        component: () => import("./views/user/viptasklist.vue")
    },{
        path: "/teamhis",
        name: "teamhis",
        component: () => import("./views/user/teamhis.vue")
    },{
        path: "/teamreg",
        name: "teamreg",
        component: () => import("./views/user/teamreg.vue")
    },{
        path: "/safe",
        name: "safe",
        component: () => import("./views/user/safe.vue")
    },{
        path: "/setpwd",
        name: "setpwd",
        component: () => import("./views/user/setpwd.vue")
    },{
        path: "/setpaypwd",
        name: "setpaypwd",
        component: () => import("./views/user/setpaypwd.vue")
    },{
        path: "/order",
        name: "order",
        component: () => import( "./views/user/order.vue")
    },{
		    path: "/ordering",
		    name: "ordering",
		    component: () =>
		        import( "./views/user/ordering.vue")
		},{
		    path: "/orderfrezee",
		    name: "orderfrezee",
		    component: () =>
		        import( "./views/user/orderfrezee.vue")
		},{
		    path: "/ordersettle",
		    name: "ordersettle",
		    component: () =>
		        import( "./views/user/ordersettle.vue")
		},{
        path: "/order",
        name: "order",
        component: () => import("./views/user/order.vue")
    },{
		    path: "/ordered",
		    name: "ordered",
		    component: () =>
		        import( "./views/user/ordered.vue")
		},{
		    path: "/odetail",
		    name: "odetail",
		    component: () =>
		        import( "./views/user/odetail.vue")
		},
		{
		    path: "/grap",
		    name: "grap",
		    component: () => import( "./views/user/grap.vue")
		},{
        path: "/funds",
        name: "funds",
        component: () => import("./views/user/funds.vue")
    },
    {
        path: "/myTeam",
        name: "myTeam",
        component: () => import("./views/user/myTeam.vue")
    },
    {
        path: "/notice",
        name: "notice",
        component: () => import("./views/user/notice.vue")
    },
    {
        path: "/notice/:id",
        name: "noticeid",
        component: () => import("./views/user/notice_article.vue")
    },
    {
        path: "/agreement/:id",
        name: "agreement",
        component: () => import("./views/user/agreement.vue")
    },
    {
        path: "/about",
        name: "about",
        component: () => import("./views/user/about.vue")
    },
    {
        path: "/about/:code",
        name: "article",
        component: () => import("./views/user/article.vue")
    },
    {
        path: "/search",
        name: "search",
        component: () => import("./views/item/search.vue")
    },
    {
        path: "/kefu",
        name: "kefu",
        component: () => import("./views/user/kefu.vue")
    },
    {
        path: "/luckDraw",
        name: "luckDraw",
        component: () => import("./views/user/luckDraw.vue")
    },
    {
        path: "/authEmail",
        name: "authEmail",
        component: () => import("./views/user/authEmail.vue")
    },{
        path: "/language",
        name: "language",
        component: () => import("./views/user/language.vue")
    },{
        path: "/blindbox",
        name: "blindbox",
        component: () => import("./views/user/blindbox.vue")
    },{
        path: "/blindboxhis",
        name: "blindboxhis",
        component: () => import("./views/user/blindboxhis.vue")
    },{
        path: "/docs",
        name: "docs",
        component: () => import("./views/index/docs.vue")
    },{
        path: "/apps",
        name: "apps",
        component: () => import("./views/index/apps.vue")
    },{
        path: "/aboutus",
        name: "aboutus",
        component: () => import("./views/index/about.vue")
    },{
        path: "/video",
        name: "video",
        component: () => import("./views/video/video.vue")
    },{
        path: "/uvshow/:code",
        name: "uvshow",
        component: () => import("./views/video/show.vue")
    },{
        path: "/uvlist",
        name: "uvlist",
        component: () => import("./views/video/list.vue")
    },{
        path: "/vtasklist",
        name: "vtasklist",
        component: () => import("./views/user/vtasklist.vue")
    },{
        path: "/lucky",
        name: "lucky",
        component: () => import("./views/user/lucky.vue")
    },{
        path: "/found",
        name: "found",
        component: () => import("./views/user/found.vue")
    },{
        path: "/test",
        name: "test",
        component: () => import("./views/user/test.vue")
    },{
        path: "/luckyhis",
        name: "luckyhis",
        component: () => import("./views/user/luckyhis.vue")
    },{
        path: "/recharge",
        name: "recharge",
        component: () => import("./views/user/recharge.vue")
    },{
        path: "/vips",
        name: "vips",
        component: () => import("./views/user/vips.vue")
    },{
        path: "/moban",
        redirect: "/moban/index"
    },
    {
        path: "/moban/account",
        name: "moban_account",
        component: () => import("./views/moban/account.vue")
    },
    {
        path: "/moban/accountchanges",
        name: "moban_accountchanges",
        component: () => import("./views/moban/accountchanges.vue")
    },
    {
        path: "/moban/accountchanges_type_withdraw",
        name: "moban_accountchanges_type_withdraw",
        component: () => import("./views/moban/accountchanges_type_withdraw.vue")
    },
    {
        path: "/moban/activity",
        name: "moban_activity",
        component: () => import("./views/moban/activity.vue")
    },
    {
        path: "/moban/agent",
        name: "moban_agent",
        component: () => import("./views/moban/agent.vue")
    },
    {
        path: "/moban/agent__2",
        name: "moban_agent__2",
        component: () => import("./views/moban/agent__2.vue")
    },
    {
        path: "/moban/appdown",
        name: "moban_appdown",
        component: () => import("./views/moban/appdown.vue")
    },
    {
        path: "/moban/bankcard",
        name: "moban_bankcard",
        component: () => import("./views/moban/bankcard.vue")
    },
    {
        path: "/moban/dayreport",
        name: "moban_dayreport",
        component: () => import("./views/moban/dayreport.vue")
    },
    {
        path: "/moban/encryptioncurrency",
        name: "moban_encryptioncurrency",
        component: () => import("./views/moban/encryptioncurrency.vue")
    },
    {
        path: "/moban/found",
        name: "moban_found",
        component: () => import("./views/moban/found.vue")
    },
    {
        path: "/moban/help",
        name: "moban_help",
        component: () => import("./views/moban/help.vue")
    },
    {
        path: "/moban/home",
        name: "moban_home",
        component: () => import("./views/moban/home.vue")
    },
    {
        path: "/moban/home__2",
        name: "moban_home__2",
        component: () => import("./views/moban/home__2.vue")
    },
    {
        path: "/moban/home__3",
        name: "moban_home__3",
        component: () => import("./views/moban/home__3.vue")
    },
    {
        path: "/moban/home__4",
        name: "moban_home__4",
        component: () => import("./views/moban/home__4.vue")
    },
    {
        path: "/moban/index",
        name: "moban_index",
        component: () => import("./views/moban/index.vue")
    },
    {
        path: "/moban/login",
        name: "moban_login",
        component: () => import("./views/moban/login.vue")
    },
    {
        path: "/moban/lucky",
        name: "moban_lucky",
        component: () => import("./views/moban/lucky.vue")
    },
    {
        path: "/moban/onlinerecharge",
        name: "moban_onlinerecharge",
        component: () => import("./views/moban/onlinerecharge.vue")
    },
    {
        path: "/moban/recharge",
        name: "moban_recharge",
        component: () => import("./views/moban/recharge.vue")
    },
    {
        path: "/moban/reg",
        name: "moban_reg",
        component: () => import("./views/moban/reg.vue")
    },
    {
        path: "/moban/reg__2",
        name: "moban_reg__2",
        component: () => import("./views/moban/reg__2.vue")
    },
    {
        path: "/moban/task",
        name: "moban_task",
        component: () => import("./views/moban/task.vue")
    },
    {
        path: "/moban/taskdetail_id_787",
        name: "moban_taskdetail_id_787",
        component: () => import("./views/moban/taskdetail_id_787.vue")
    },
    {
        path: "/moban/usercenter",
        name: "moban_usercenter",
        component: () => import("./views/moban/usercenter.vue")
    },
    {
        path: "/moban/usercenter__2",
        name: "moban_usercenter__2",
        component: () => import("./views/moban/usercenter__2.vue")
    },
    {
        path: "/moban/vip",
        name: "moban_vip",
        component: () => import("./views/moban/vip.vue")
    },
    {
        path: "/moban/withdrawal",
        name: "moban_withdrawal",
        component: () => import("./views/moban/withdrawal.vue")
    },
    {
        path: "/moban/withdrawal__2",
        name: "moban_withdrawal__2",
        component: () => import("./views/moban/withdrawal__2.vue")
    },
];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes
});

export default router;


